import { render } from "./AppAnswer.vue?vue&type=template&id=19e72560"
import script from "./AppAnswer.vue?vue&type=script&lang=js"
export * from "./AppAnswer.vue?vue&type=script&lang=js"

import "./AppAnswer.vue?vue&type=style&index=0&id=19e72560&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__